module.exports = __webpack_public_path__ + "static/media/validacao.8b984738.svg";